.setPinDetail {
  display: flex;
  flex-direction: column;
  padding: var(--spacing-12) 0;
  gap: var(--spacing-08);

  .latLngContainer,
  .radiusContainer {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .latLngInput {
      width: 15ch;

      input {
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    .radiusInput {
      width: 70px;
    }
  }

  .pointList {
    display: flex;
    flex-direction: column;

    .point {
      display: flex;
      align-items: center;
      column-gap: var(--spacing-08);
    }

    .bullet {
      display: block;
      height: 6px;
      width: 6px;
      background-color: var(--sparky-red-400);
      border-radius: 100%;
    }
  }
}
